var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle4D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_hairstyle:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32__5_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M471.4,155.8c-0.7-1.7-1.5-3.3-2.4-4.8c-3.2-5.7-7.7-10.6-13.4-13.6c2.4-7.6-2.1-16.8-7.5-22.1 c-9.7-8.9-20.8-15.5-32.5-19.3c-2.4-0.8-4.7-1.4-7.2-1.9c-8-2.3-16.1-3.7-24.2-4.4c-2.7-0.2-5.4-0.4-8.1-0.5 c-18.2-0.4-37.1,1-55.3,6c-2.6,0.7-5.2,1.5-7.7,2.3c-24.1,9.2-47.3,25.1-56.3,50.4c-0.9,2.2-1.8,4.5-2.5,6.7 c-1.1,3.4-2.1,6.9-2.9,10.5c-2.8,12.3-3.2,24.5-1.6,36.6c0.3,2.4,0.7,4.8,1.2,7.2c2.9,17.3,10.2,33.2,14.9,49.7 c0-20.1,8.8-40,25-52.4c18.1-13.8,38.7-27.3,59.9-34.9c-18.5,12.2-33.4,23.8-50.1,34.5c15.1-2.1,24.7-5.4,36.9-9.9 c11.1-4.1,30-10.3,39.3-17.6c-14.5,12-29,25.4-47.4,31.4c11.4,1.7,25.4-2.7,36.2-6.4c11.6-4,20-7.7,31.3-12.8 c7.7-3.4,24.5-11.4,34.1-18c10.9,14,11.9,33.4,13.8,50.2c0.1,2.1,0.3,4.1,0.5,6.2c0.3,4.1,0.7,8.2,1.4,12.2 c0.2,1.7,0.5,3.4,0.7,5.2c0.8,6.1,1.8,12.6,3.7,18.7c1.5-10.1,5.3-19.2,9.8-28c0.8-1.5,1.6-3.1,2.5-4.6 c4.4-6.1,7.2-12.6,9.1-19.4c0.5-1.7,0.9-3.4,1.2-5.1C476.6,190.8,479.7,171.7,471.4,155.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#87634D",
    d: "M349,105.7c-33.2,3.4-60.6,23.2-78.5,52c-17.5,30.4-15,64.8-4.3,94.1c0.4-4.3,1.3-8.6,2.5-12.7 C253.2,174.5,293.2,120.8,349,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87634D",
    d: "M316.5,175.1c3.9-2.2,10.3-5.5,14.4-7.4c27.7-13.7,63.2-20.6,77.1-47c-25.3,18.1-55.9,21.3-82.9,34.7 c-4.6,2.3-9.1,4.7-13.5,7.4c-25,15.4-43.8,37.7-40.1,68.6c2.5-5.8,5.9-11.2,10-16C287.4,196.9,300.2,184.4,316.5,175.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#87634D",
    d: "M439.8,144c-25.4,22.8-55.2,38.4-85.4,52.5c-7.7,5.5-15.8,10.4-25,13.3c11.4,1.7,25.4-2.7,36.2-6.4 c11.6-4,20-7.7,31.3-12.8c3.1-1.4,7.5-3.4,12.4-5.8C422,173.4,432.4,159.6,439.8,144z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle4D);
export default __webpack_public_path__ + "static/media/man_hairstyle_4d.8181933f8a07ce3aa1a280da747c3f31.svg";
export { ForwardRef as ReactComponent };